import React from 'react';

import PropTypes from 'prop-types';

import { ReturnLabel } from '../../../../../../../containers/print-document-button-containers/return-details/components/return-label';
import { CopyTrackingNumberMenuItem } from '../../../../../rate-card/read-only/label-actions/copy-tracking';
import { useIsCopyTrackingEnabledForReturn } from '../../../../../rate-card/read-only/label-actions/copy-tracking/hooks';
import { useEntitiesReturn } from '../../../../../../../hooks/entities/selectors/returns';
import { ReturnStatus } from '../../../../../../../enums/return-status';
import messages from '../../../../../rate-card/read-only/label-actions/messages';
import { VoidReturnLabel } from './void-return-label';
import { MarkAsReceived } from './mark-as-received';
import { SendReturnLabel } from './send-return-label';

const LabelDetailsActions = ({ returnFulfillmentId, trackingNumber, isVoided = false }) => {
  const returnFulfillment = useEntitiesReturn(returnFulfillmentId) || {};
  const shouldShowMarkAsReceived = returnFulfillment?.returnStatus === ReturnStatus.Outstanding.toString();

  const isCopyTrackingEnabled = useIsCopyTrackingEnabledForReturn(returnFulfillmentId);
  return (
    <>
      <ReturnLabel fulfillmentId={returnFulfillmentId} messageDescriptor={messages.printLabel} />
      <VoidReturnLabel isDisabled={isVoided} returnFulfillmentId={returnFulfillmentId} />
      {shouldShowMarkAsReceived && <MarkAsReceived returnFulfillmentId={returnFulfillmentId} />}
      <SendReturnLabel isDisabled={isVoided} returnFulfillment={returnFulfillment} />
      <CopyTrackingNumberMenuItem isEnabled={isCopyTrackingEnabled} trackingNumber={trackingNumber} />
    </>
  );
};

export { LabelDetailsActions };

LabelDetailsActions.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
  trackingNumber: PropTypes.string,
  isVoided: PropTypes.bool,
};
